<template>
    <FloatingPanel>
        <div class="canvas-blocks-custom-header-BlockPanel">

            <div slot="Algemeen">

                <ColorsInput
                    label="2de kolom / Video achtergrondkleur"
                    instruction="Bepaal hier de kleur van de video achtergrond."
                    :colors="colors"
                    :options="options"
                    options-property="videoBgColor"
                    :open="true"
                />

                <CommonInputs :options="options" />

            </div>

        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs';
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        ColorsInput,
    },

    async mounted() {
        await this.loadColors();
    },

    data() {
        return {
            colors: null,
        };
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors(true)).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);

            let formattedColors = {};

            for (const color of this.colors) {
                if (typeof color === 'object') {
                    for (const [key, value] of Object.entries(color)) {
                        formattedColors[key] = value;
                    }
                } else {
                    formattedColors[color] = color;
                }
            }

            this.colors = formattedColors;
        },

    },
};
</script>
